import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import grey from '@mui/material/colors/grey'
import {IConceptFE} from 'interfaces/IConceptFE'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import * as React from 'react'
import {useDispatch} from 'react-redux'
import {updateSavedNotificationSearch} from 'redux/actions/savedSearchActions'
import {AppDispatch} from 'redux/store'
import {useToolbarContext} from './ToolbarProvider'

export default function ConceptWeightChangeDialog({
  search,
  concept,
  show,
  setShow,
}: {
  search: ISavedSearchFE
  concept: IConceptFE
  show: boolean
  setShow: (t: boolean) => void
}) {
  const dispatch = useDispatch<AppDispatch>()
  const {setIsDirty} = useToolbarContext()
  //const label = {inputProps: {'aria-label': 'Switch'}}
  const [weightValue, setWeightValue] = React.useState<string>(concept.__weight.toString())
  // const [ignoredValue, setIgnoredValue] = React.useState<boolean>(
  //   concept.__lock === 'exclude' ?? false
  // )

  const handleWeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inVal = (event.target as HTMLInputElement).value.toString()
    if (!search) return
    search?.concepts?.map((c) => {
      if (c.id === concept.id) {
        const copyC = {...c}
        copyC.__weight = Number.parseFloat(inVal)
        setWeightValue(inVal)
        setIsDirty(true)
        saveUpdatedConcept(copyC)
      }
    })
  }

  const saveUpdatedConcept = (c: IConceptFE) => {
    if (search?.id) {
      //const copySavedSerch = {...savedSearchOnlyRedux}
      const concepts = search.concepts?.map((x) => {
        if (x.id === c.id) {
          return {
            id: x.id,
            name: x.name,
            qid: x.qid,
            score: x.score,
            aliases: x.aliases,
            businesses: x.businesses,
            related_concepts: x.related_concepts,
            __notes: x.__notes,
            __lock: c.__lock === 'exclude' ? 'exclude' : 'include',
            __weight: c.__weight ?? 1,
          } as IConceptFE
        } else {
          return {
            id: x.id,
            name: x.name,
            qid: x.qid,
            score: x.score,
            aliases: x.aliases,
            businesses: x.businesses,
            related_concepts: x.related_concepts,
            __notes: x.__notes,
            __lock: x.__lock,
            __weight: x.__weight,
          } as IConceptFE
        }
      })
      const coy_search = {...search}
      coy_search.concepts = concepts
      dispatch(
        updateSavedNotificationSearch({
          id: search.id,
          search: coy_search,
          originalSavedSearch: search,
        })
      )
    }
  }

  return (
    <Dialog open={show} onClose={() => setShow(false)} fullWidth>
      <DialogTitle id='scroll-dialog-title'>
        Edit Concept: <b>{concept.name ?? 'Name of Concept Here'} </b>
      </DialogTitle>
      <Divider sx={{bgcolor: grey[50], height: '5px'}} />
      <DialogContent>
        {/* <Box>
          <FormControl>
            <FormLabel id='demo-row-radio-buttons-group-label'>
              Include or Ignore Concept:
            </FormLabel>
            <FormControlLabel
              control={<Switch {...label} checked={!ignoredValue} onChange={handleIgnoreChange} />}
              label={`Concept ${!ignoredValue ? 'included' : 'ignored'}`}
            />
          </FormControl>
        </Box> */}

        <Box>
          <FormControl>
            <FormLabel id='demo-row-radio-buttons-group-label'>Concept Search Weight:</FormLabel>
            <RadioGroup
              row
              aria-labelledby='demo-row-radio-buttons-group-label'
              name='row-radio-buttons-group'
              value={weightValue}
              onChange={handleWeightChange}
            >
              <FormControlLabel value='0' control={<Radio />} label='low' />
              <FormControlLabel value='0.5' control={<Radio />} label='Medium' />
              <FormControlLabel value='1' control={<Radio />} label='High' />
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setShow(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
